import React from "react";
import '../styles/table-style.css';

import first from '../img/first.jpg'
import second from '../img/second.jpg'
import third from '../img/third.jpg'
import cinema from '../img/photomaraphon.jpg'
import kino from '../img/kino.jpg'
import game from '../img/game.jpg'

class Tabled extends React.Component {
    render() {
        return(
            <table>
                <td className='td'>
                    <img className='brainFight' src={third} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/8'>
                            Масленица
                        </a>
                    </div>
                </td>
                <td className='td'>
                    <img className='brainFight' src={second} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/5'>
                            Встреча языкового клуба
                        </a>
                    </div>
                </td>
                <td className='td'>
                    <img className='brainFight' src={first} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/2'>
                            Запуск сайта УрФУ.События
                        </a>
                    </div>
                </td>
                <td className='td'>
                    <img className='brainFight' src={kino} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/11'>
                            Киновечер
                        </a>
                    </div>
                </td>
                <td className='td'>
                    <img className='brainFight' src={game} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/10'>
                            Вечер интеллектуальных игр
                        </a>
                    </div>
                </td>
                <td className='td'>
                    <img className='brainFight' src={cinema} />
                    <div className='title'>
                        <a className='eventlink' target='_blank' href='https://loozmax.github.io/event-urfu/#/api/events/12'>
                            Фотомарафон
                        </a>
                    </div>
                </td>
            </table>
        )
    }
}

export default Tabled;